// De Afmeldtermijn: tot hoeveel uur voor de start van een tijdslot een deelnemer
// zijn eigen boeking nog kan afmelden of wijzigen. Het is dezelfde grens als in de
// API (EnrollmentService::isPastCancellationWindow). Wijzigen valt eronder, anders
// wijzig je naar een later tijdslot en meld je je daar alsnog af (ClickUp
// 1240ccedn8d).
//
// `date` is de epoch (seconden) van middernacht Europe/Amsterdam, `start` "HH:MM".
// De termijn telt terug vanaf de starttijd van het tijdslot, niet vanaf middernacht.
export function isPastCancellationWindow(periodHours, date, start, now = Date.now()) {
  const [hours = 0, minutes = 0] = String(start ?? "").split(":").map(Number);
  const slotStartMs = (Number(date) + hours * 3600 + minutes * 60) * 1000;

  return now > slotStartMs - (Number(periodHours) || 0) * 3600 * 1000;
}
